<template>
  <div class="home">
    <div class="box">
      <div class="left">
        <div class="header-title">
          <span class="one">icon</span>
          <span class="two">Home</span>
        </div>
        <div class="left-footer">
          <div class="tab-list">
            <div
              class="list-box"
              @click="contIndex(index, item.value)"
              :class="currendIndex == index ? 'active' : ''"
              v-for="(item, index) in categoryList"
              :key="item.value"
            >
             <img :src="item.icon" alt="">
              {{ item.label }}
            </div>
          </div>
          <img
            class="left-img"
            src="../assets/images/homepage/home.png"
            alt=""
          />
        </div>
      </div>
      <div class="center">
        <div class="center-header" style="justify-content: space-between;">
          <div style="display: flex;">
            <div class="searchinput">
              <sa-input
                clearable
                placeholder="请输入图标关键词"
                prefix-icon="sa-icon-search"
                v-model="searchinput"
                @input="search"
              >
              </sa-input>
            </div>
            <div class="radiochoose">
              <sa-checkbox v-model="checked">只看已选：<span>{{ num }}/{{ total }}</span></sa-checkbox>
            </div>
          </div>
          <div>
            <sa-button round @click="handleStart">使用文档</sa-button>
            <sa-button round @click="handleChangeLog">更新日志</sa-button>
            <span style="margin-left: 10px;">v {{ version }}</span>
          </div>
        </div>

        <div class="contentbox">
          <div class="content" ref="itemList" @scroll="handleScroll">
            <div
              :id="item.category"
              v-for="item in iconList"
              :key="item.iconId"
              class="item1 bigbox"
            >
              <div class="title datasimba" >
                {{ getCategoryLabel(item.category) }}（{{item.list.length}}）
              </div>
              <div class="checkbox-group" :class="`${item.category}-box`">
                <template v-for="icon in item.list">
                  <div
                    class="checkbox-button"
                    v-if="(checked && icon.isChecked) || !checked"
                    :key="icon.iconId"
                    @click="checkGroup(icon)"
                    :class="icon.isChecked ? 'bgcolor' : ''"
                  >
                    <div class="wordbox">
                      <span v-if="icon.isNew" style="font-size: 12px;color: red; position: absolute; right: 10px;">new</span>
                      <span class="icon">
                        <sa-icon :name="icon.iconClass"></sa-icon>
                      </span>
                      <sa-ellipsis lineStatus="single" showOverflowTooltip>
                        <p class="wordtitle">{{ icon.name }}</p>
                      </sa-ellipsis>
                      <sa-ellipsis lineStatus="single" showOverflowTooltip>
                        <p class="enword">{{ icon.eName }}</p>
                      </sa-ellipsis>
                    </div>
                    <sa-dropdown placement="bottom">
                      <span class="sa-dropdown-link hoverbox">
                        ...
                      </span>
                      <sa-dropdown-menu placement="top" slot="dropdown">
                        <sa-dropdown-item
                          class="newDrop"
                          icon="sa-icon-plus"
                          command="copyClass"
                          v-clipboard:copy="icon.iconClass"
                          v-clipboard:success="onCopy"
                          >复制Class名称</sa-dropdown-item
                        >
                        <sa-dropdown-item
                          icon="sa-icon-plus"
                          command="copyVue"
                          v-clipboard:copy="`<sa-icon name=${getName(icon.iconClass)} />`"
                          v-clipboard:success="onCopy"
                          >复制Vue代码</sa-dropdown-item
                        >
                      </sa-dropdown-menu>
                    </sa-dropdown>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="right"></div>
    </div>
  </div>
</template>

<script>
import icons from "@/assets/icons.json";
import idNameMap from '@/assets/idNameMap.json';
import { version } from '@/../package.json';

export default {
  name: "Home",
  data() {
    return {
      total: 0,
      spanIndex: [],
      checkboxlist: [],
      checked: false,
      checkboxGroup1: [],
      listData: [],
      categoryList: [
        {
          label: "通用",
          value: "common-icon",
          icon: require("../assets/images/common.svg"),
        },
        {
          label: "DataSimba",
          value: "datasimba-next-icon",
          icon: require("../assets/images/simba.svg"),
        },
        {
          label: "SimbaTag",
          value: "simba-tag-icon",
          icon: require("../assets/images/simba.svg"),
        },
        {
          label: "SimbaMetric",
          value: "simba-metric-icon",
          icon: require("../assets/images/simba.svg"),
        },
        {
          label: "SimbaStitch",
          value: "simba-stitch-icon",
          icon: require("../assets/images/simba.svg"),
        },
        {
          label: "SimbaMl",
          value: "simba-ml-icon",
          icon: require("../assets/images/simba.svg"),
        },
        {
          label: "SimbaFabric",
          value: "simba-fabric-icon",
          icon: require("../assets/images/simba.svg"),
        },
        {
          label: "DataNuza",
          value: "nuza-icon",
          icon: require("../assets/images/nuza.svg"),
        },
        {
          label: "货架系统",
          value: "shelf-system-icon",
          icon: require("../assets/images/shelf.svg"),
        },
        {
          label: '旧DataSimba',
          value: 'datasimba-icon',
          icon: require('../assets/images/simba.svg'),
        }
      ],
      iconList: [],
      searchinput: "",
      currendIndex: 0,
      scrollY: 0, //左侧列表滑动的y轴坐标
      rightBscroll: -1,
      index: 0,
      clickCount: 0,
      checklist: [], //选中的id
      searchList: [],
      version,
    };
  },
  created() {
    const newIconList = [];
    this.iconList = icons.map((cate) => {
      return {
        category: cate.category,
        list: cate.list.map((icon) => {
          this.total ++;
          if (!idNameMap[icon.iconId]) {
            newIconList.push({
              [icon.iconId]: icon.eName
            })
          }
          return {
            ...icon,
            name: idNameMap[icon.iconId] || icon.name || '未定义',
            isNew: cate.category !== 'datasimba-icon' && (!idNameMap[icon.iconId]),
            isChecked: false,
          };
        }),
      };
    });
    this._iconList = JSON.parse(JSON.stringify(this.iconList));
  },
  computed: {
    num() {
      let num = 0;
      this.iconList.map((item) => {
        item.list.map((icon) => {
          if (icon.isChecked) {
            num = num + 1;
          }
        });
      });
      return num;
    },
  },
  methods: {
    getName(iconClass) {
      const [cate, icon] = iconClass.split(' ');
      return `"${cate}-${icon.slice(5)}"`;
    },
    handleStart() {
      window.location.href='/docs/index.html#/start'
    },
    handleChangeLog() {
      window.location.href='/docs/index.html#/changeLog'
    },
    onCopy() {
      this.$message.success('复制成功');
    },
    getCategoryLabel(value) {
      return this.categoryList.find((cate) => {
        return cate.value == value;
      }).label;
    },
    search() {
      this.total = 0;
      this.iconList = this._iconList.map(cate => {
        const list = cate.list.filter(icon => {
            this.total ++;
            return icon.name.indexOf(this.searchinput) != -1  || icon.eName.indexOf(this.searchinput) != -1
          })
        return {
          category: cate.category,
          list,
        }
      })
    },
    checkGroup(icon) {
      icon.isChecked = !icon.isChecked;
    },
    handleScroll(event) {
      this.scrollY = event.target.scrollTop;
    },
    contIndex(index, itemList) {
      this.currendIndex = index;
      this.iconList.map((item) => {
        if (item.category === itemList) {
          this.listData = {
            list: item.list,
            listTitle: item.category,
          };
          // this.listData = item.list
        }
      });
      // {behavior: "smooth"}滚动效果
      // document.getElementById(itemList).scrollIntoView({oblock:"start"})
      const targer = window.document.getElementById(itemList);
      const target = window.document.getElementsByClassName("contentbox");
      target[0].scrollTop = targer.offsetTop - 90;
    },
  },
  mounted() {
  },
};
</script>

<style lang="scss" scoped>
.home {
  min-height: 800px;
  min-width: 1440px;
  .box {
    display: flex;
    .left {
      width: 220px;
      .header-title {
        height: 80px;
        line-height: 80px;
        text-align: center;
        .one {
          font-weight: 600;
          font-size: 28px;
          color: #3b3830;
          padding-right: 5px;
        }
        .two {
          font-weight: 600;
          font-size: 28px;
          color: rgba(52, 143, 108, 1);
        }
      }
      .left-footer {
        position: relative;
        border-radius: 0px 100px 0px 0px;
        background: #348f6c;
        height: calc(100vh - 80px);
        .left-img {
          position: absolute;
          bottom: 40px;
          width: 180px;
          height: 180px;
          margin-left: 20px;
        }
        .tab-list {
          padding-top: 50px;
          margin: 0 20px;
          .list-box {
            padding-left: 32px;
            width: 180px;
            height: 40px;
            cursor: pointer;
            font-size: 16px;
            font-weight: 600;
            color: rgba(255, 255, 255, 0.4);
            display: flex;
            align-items: center;
            margin-bottom: 10px;
            img {
              width: 16px;
              height: 16px;
              margin-right: 12px;
            }
          }
        }
        .active {
          background: rgba(0, 0, 0, 0.2);
          border-radius: 27px;
          color: #fff !important;
          opacity: 1;
          img {
            color: #fff !important;
          }
        }
      }
    }
    .right {
      display: none;
      // width: 373px;
      // height: 1080px;
      // background: #f3f3f3;
    }
    .center {
      width: 100%;
      flex: 1;
      height: 100vh;
      .center-header {
        margin: 0 40px;
        display: flex;
        height: 80px;
        line-height: 80px;
        border-bottom: 1px solid #dedede;
        .searchinput {
          ::v-deep .sa-input__inner {
            width: 400px;
            height: 40px;
            background: #f0f0f0;
            border-radius: 20px;
            border: 0;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
          }
        }
        .radiochoose {
          margin-left: 40px;
          ::v-deep .sa-radio__inner {
            border-radius: 4px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #0b150f;
          }
        }
        ::v-deep .sa-checkbox__input.is-checked + .sa-checkbox__label {
          color: #348f6c;
        }
        ::v-deep .sa-checkbox__input.is-checked .sa-checkbox__inner,
        .sa-checkbox__input.is-indeterminate .sa-checkbox__inner {
          background-color: #348f6c;
        }
        ::v-deep .sa-checkbox__inner:hover {
          border-color: #348f6c;
        }
      }
      .contentbox {
        margin-left: 40px;
        height: calc(100% - 80px);
        overflow-y: auto;
        .bg-purple {
          background: #d3dce6;
        }
        .grid-content {
          border-radius: 4px;
          min-height: 36px;
        }
        .content {
          .bigbox {
            display: flex;
            flex-wrap: wrap;
            .datasimba {
              width: 100%;
              height: 70px;
              line-height: 70px;
              font-size: 22px;
              font-family: PingFangSC-Semibold, PingFang SC;
              font-weight: 600;
              color: #0b150f;
            }
            ::v-deep .sa-dropdown {
              display: inline-block;
              position: absolute;
              top: 4px;
              right: 10px;
              color: #707070;
              font-size: 20px;
              cursor: pointer;
            }
            .checkbox-group {
              width: 100%;
              display: flex;
              flex-wrap: wrap;
              justify-content: flex-start;
              .checkbox-button {
                position: relative;
                width: 206px;
                height: 72px;
                margin-right: 12px;
                margin-bottom: 12px;
                background: #fafafa;
                border-radius: 8px;
                border: 1px solid #fafafa;
                cursor: pointer;
                .wordbox {
                  position: relative;
                  & p {
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    width: 170px;
                  }
                  .icon {
                    vertical-align: middle;
                    position: absolute;
                    top: 15px;
                    left: 22px;
                  }

                  .wordtitle {
                    padding-left: 57px;
                    padding-top: 13px;
                    font-size: 14px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #0b150f;
                  }

                  .enword {
                    padding-left: 21px;
                    margin-top: 8px;
                    font-size: 12px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #939694;
                  }
                }
              }
              .bgcolor {
                background: rgba(234, 245, 241, 1);
                border: 1px solid #348f6c;
                color: #348f6c;
              }
           
            }
           
          }
        }
      }
    }
  }
}
</style>
<style lang="scss">
.sa-dropdown-menu__item:not(.is-disabled):hover {
    background-color: #e6eefc;
    color: #348f6c;
}
.sa-button {
  border-color: #fff;
  background-color: #F3F3F3;
}
.sa-button:hover {
  color: #348F6C;
  border-color: #EAF5F1;
  background-color: #EAF5F1;
}
</style>
